import { Modal } from 'react-bootstrap'
import styled from 'styled-components'

export const HeaderStyled = styled(Modal.Header)`
  font-size: 1.6rem;
`
